export default __webpack_public_path__ + "static/media/3.14.ef3859f2.mp3";